import { useEffect, useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../runtimeConfig';

/*
  Licence state of this install (docs/LICENSING.md). Our cloud answers
  { mode: 'cloud' } and nothing else changes; a self-hosted install answers its
  lease state. Cached for a minute; fails open, the backend enforces anyway.
*/

let cache = null;
const TTL_MS = 60 * 1000;

export function peekInstanceLicence() {
  return cache && Date.now() - cache.at < TTL_MS ? cache.data : null;
}

export async function fetchInstanceLicence(api, { fresh = false } = {}) {
  if (!fresh) {
    const cached = peekInstanceLicence();
    if (cached) return cached;
  }
  try {
    const r = await axios.get(`${api}/instance/licence`);
    cache = { at: Date.now(), data: r.data || { mode: 'cloud' } };
  } catch (_e) {
    cache = { at: Date.now(), data: { mode: 'cloud', unavailable: true } };
  }
  return cache.data;
}

export function invalidateInstanceLicence() {
  cache = null;
}

// True on a self-hosted install. Starts from the cached answer so a page that
// renders after the licence gate does not flash cloud-only entries.
export function useSelfHosted() {
  const [selfHosted, setSelfHosted] = useState(() => {
    const cached = peekInstanceLicence();
    return Boolean(cached && cached.mode === 'self_hosted');
  });
  useEffect(() => {
    let alive = true;
    fetchInstanceLicence(`${BACKEND_URL}/api`).then((d) => {
      if (alive) setSelfHosted(Boolean(d && d.mode === 'self_hosted'));
    });
    return () => {
      alive = false;
    };
  }, []);
  return selfHosted;
}
